import React from "react";
import { imageCodes, titleCodes, textCodes } from "../../template_codes/sarphosaung/about_page_codes";

function About() {
    return (
        <div>
            <div className="lg:w-4/5 xl:w-4/5 lg:pt-20 xl:pt-20 px-4 lg:pl-14 xl:pl-14">
                <h1 className="text-xl lg:text-xl xl:text-xl py-8">{titleCodes.aboutTitle.title}</h1>
                <p className="pb-4 leading-loose text-justify">{textCodes.about1.text}</p>
                <p>{textCodes.about2.text}</p>
            </div>
            <h1 className="text-2xl lg:text-4xl px-4 xl:text-4xl lg:pl-14 xl:pl-14 pt-10">{titleCodes.news.title}</h1>
            <div className="grid grid-cols-1 lg:grid-cols-2 xl:grid-cols-2 gap-0 pt-10 px-4 lg:px-14 xl:px-14">
                <div>
                    <img src={imageCodes.oil.image} alt="packaging" width={560} height={280} />
                </div>
                <div>
                    <h1 className="text-xl lg:text-2xl xl:text-2xl pt-4">{titleCodes.news1.title}</h1>
                    <p className="pt-4 leading-loose text-justify">{textCodes.local1.text}</p>
                    <p>{textCodes.local2.text}</p>
                </div>
                <div className="pt-8">
                    <img src={imageCodes.rice.image} alt="packaging" width={560} height={280} />
                </div>
                <div>
                    <h1 className="text-xl lg:text-2xl xl:text-2xl lg:pt-10 xl:pt-10 pt-4">{titleCodes.news2.title}</h1>
                    <p className="pt-4">{textCodes.rice1.text}</p>
                    <p className="pl-2 pt-2 leading-loose text-justify">{textCodes.rice2.text}</p>
                    <p className="pl-2 pt-2 leading-loose text-justify">{textCodes.rice3.text}</p>
                    <p className="pt-2">{textCodes.rice4.text}</p>
                </div>
                <div className="pt-8">
                    <img src={imageCodes.sunoil.image} alt="packaging" width={560} height={280} />
                </div>
                <div>
                    <h1 className="text-xl lg:text-2xl xl:text-2xl lg:pt-10 xl:pt-10 pt-4">{titleCodes.news3.title}</h1>
                    <p className="pl-2 pt-4">{textCodes.oil1.text}</p>
                    <p className="pl-2 pt-2">{textCodes.oil2.text}</p>
                    <p className="pt-4 leading-loose text-justify">{textCodes.oil3.text}</p>
                    <p className="pt-4 leading-loose text-justify">{textCodes.oil4.text}</p>
                </div>
            </div>
        </div>
    );
}

export default About;